import { Client } from '../client/client';
import {Machine} from '../machine/machine';
import {User} from '../user/user';

export class Maintenance 
{
id : number; 
visitdetails : string; 
conclusion : string; 
notes : string; 
counter : number ; 
dateofvisit : Date;
machine : Machine; 
user : User ; 
client : Client; 
}
